// src/pages/RoomChat.jsx
import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { SocketContext } from "../contexts/SocketContext";
import "./RoomChat.scss";

const RoomChat = () => {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const {
    socket, isConnected, userId,
    joinRoom, sendMessage, deleteMessage,
    onInitMessages, onMessage, onDeleteMessage
  } = useContext(SocketContext);

  const [messages, setMessages] = useState([]);
  const [text, setText]       = useState("");
  const endRef = useRef(null);

  // 1) roomId / userId 없으면 redirect
  useEffect(() => {
    // if (!roomId)   return navigate("/rooms");
    // if (!userId)   return navigate("/login");
    // if (!socket)   return;
    // if (!isConnected) return;
    if (!roomId) return navigate("/rooms");
    if (!socket || !isConnected || userId === null) return;   // userId 확정까지 대기
    const handleInit    = msgs => setMessages(msgs);
    const handleReceive = msg  => setMessages(ms => [...ms, msg]);
    const handleDelete  = id   => setMessages(ms => ms.filter(m=>m._id!==id));

    onInitMessages(handleInit);
    onMessage(handleReceive);
    onDeleteMessage(handleDelete);

    joinRoom(roomId);

    return () => {
      socket.off("initMessages", handleInit);
      socket.off("receiveMessage", handleReceive);
      socket.off("messageDeleted", handleDelete);
    };
  }, [
    roomId, userId, socket, isConnected,
    joinRoom, onInitMessages, onMessage, onDeleteMessage, navigate
  ]);

  // 2) 자동 스크롤
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSendClick = () => {
    if (!text.trim()) return;
    sendMessage({ roomId, message: text.trim() });
    setText("");
  };

  const handleDeleteClick = id => {
    if (window.confirm("정말 삭제할까요?")) deleteMessage(id, roomId);
  };

  return (
    <div className="room-chat-container">
      <div className="room-chat-header">
        <h2># {roomId}</h2>
        <button onClick={()=>navigate("/rooms")}>방 목록</button>
      </div>
      <div className="room-chat-messages">
        {messages.map(msg => (
          <div key={msg._id}
               className={`message-bubble ${msg.userId?._id === userId ? "my-message":""}`}>
            <div className="message-user">
              {msg.userId?.nickname || msg.userId?._id || "익명"}
            </div>
            <div className="message-text">{msg.message}</div>
            {msg.userId?._id === userId && (
              <button onClick={()=>handleDeleteClick(msg._id)}>
                삭제
              </button>
            )}
          </div>
        ))}
        <div ref={endRef}/>
      </div>
      <div className="room-chat-input">
        <input
          value={text}
          onChange={e=>setText(e.target.value)}
          onKeyDown={e=>e.key==="Enter"&&handleSendClick()}
          placeholder="메시지를 입력하세요"
          disabled={!isConnected}
        />
        <button onClick={handleSendClick} disabled={!isConnected}>
          전송
        </button>
      </div>
    </div>
  );
};

export default RoomChat;
